<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="equipeSvc"></yo-generic-datagrid-pn>
